import AbstractField from "./AbstractField";
import InputField from "./InputField";

export default class MultiField extends AbstractField {
    isInputField = true;
    inputs = [];

    populate(element) {
        this.inputs.map(input => {
            input.reset();
            input.hide();
        });

        for (let i = 0; i < element.length; i++) {
            let input = this.getInput(i);
            input.populate(element.segmentLength(i));
            input.show();
            input.field.elt.onmouseover = () => element.hoverSegment(i);
            input.field.elt.onmouseout = () => element.hoverSegment(null);
        }
    }

    make() {
        this.field = this.p.createDiv();
        this.applyStyles();
        this.initialized = true;
        return this;
    }

    getInput(index) {
        return this.inputs[index] ?? this.makeInput(index);
    }

    makeInput(index) {
        let func;
        if (this.isDrawInput) {
            func = () => {
                let coordinate = this.getTool('shapes').currentMode.coordinates[index + 1];
                if (coordinate) {
                    let previousCoordinate = this.getTool('shapes').currentMode.coordinates[index];
                    coordinate.setLengthFromCoordinate(value, previousCoordinate);
                } else {
                    input.makeSticky();
                }
            }
        } else {
            func = (element, value) => {
                element.setSegmentLength(index, value);
            }
        }
        let input = InputField.setup(this.provider)
            .parent(this.field)
            .dimension()
            .attribute('segment')
            .label('Segment ' + (index + 1))
            .id('segment-' + (index + 1))
            .setPopulate((length, field) => field.value(length))
            .input(func)
            .make();
        this.inputs.push(input);
        return input;
    }

    highlightSegment(index) {
        this.unhighlightSegment();
        let input = this.inputs[index];
        if (input) {
            input.inputElement.style('border', '2px solid rgb(0, 50, 180)');
            this._highlightedIndex = index;
        }
    }

    unhighlightSegment() {
        if (this._highlightedIndex !== undefined) {
            let input = this.inputs[this._highlightedIndex];
            if (input) input.inputElement.style('border', '');
            this._highlightedIndex = undefined;
        }
    }

    reset() {
        this.unhighlightSegment();
        this.inputs.map((input) => {
            input.reset();
            input.hide();
        });
    }
}
